import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CopiaSeguridad({ modo }) {
  const [e, setE] = useState(null);

  useEffect(() => {
    axios.get(`${API}/copia-seguridad/estado`).then((r) => setE(r.data)).catch(() => {});
  }, []);

  if (!e || !e.visible) return null;
  const cuando = e.ultima ? new Date(e.ultima).toLocaleString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : null;
  const texto = e.ok
    ? `Copia de seguridad: ${cuando} · ${e.mb} MB`
    : e.ultima ? `Sin copia de seguridad reciente: la última fue hace ${Math.round(e.horas / 24)} día(s) (${cuando})` : "No hay ninguna copia de seguridad";

  if (modo === "banner") {
    return e.ok ? null : <div className="mb-4 px-4 py-2 rounded-lg bg-red-600 text-white text-sm font-medium">⚠ {texto}</div>;
  }
  return <p className={`text-sm ${e.ok ? "text-emerald-700" : "text-red-700 font-medium"}`}>{e.ok ? "✓ " : "⚠ "}{texto}</p>;
}
